import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { get } from 'lodash'
import ReactHtmlParser from 'react-html-parser'
import { userCheckMobileScreen } from 'helpers/tools'
import Typography from 'components/atoms/Typography/Typography'
import Image from 'components/atoms/Image'
import CustomButton from 'components/atoms/CustomButton/CustomButton'

// Style
import './StepByStep.scss'

function StepByStep({ data }) {
  const isMobile = userCheckMobileScreen()
  return (
    <Container className="step-by-step">
      <Row>
        <Col sm={12} lg={8}>
          <Typography cssClass="title-book-xs" color="secondary">
            {get(data, 'title')}
          </Typography>
        </Col>
      </Row>

      <Container className="step-by-step mt-4">
        {get(data, 'steps').map(({ entity }, index) => (
          <Row className="py-lg-5 pb-3 pt-4 step" key={get(entity, 'uuid')}>
            <Col sm={12} lg={{ span: 2, offset: 1 }} className="d-flex align-items-lg-start align-items-center">
              <div className="circle">
                <span className="circle__number title-semibold-lg">{index + 1}</span>
              </div>
              <Typography cssClass="step__indication-mobile ml-3 semibold" variant="p">
                {get(entity, 'title')}
              </Typography>
            </Col>
            <Col lg={9}>
              <Typography cssClass="step__indication-desktop semibold" variant="p">
                {get(entity, 'title')}
              </Typography>
              <Typography variant="span" color="gray-100" cssClass="my-4 step__description">
                {ReactHtmlParser(get(entity, 'description.value'))}
              </Typography>
              {(get(entity, 'downloadButton') || get(entity, 'download')) && (
                <CustomButton
                  href={
                    get(entity, 'download.entity.absoluteLink.url.path') ||
                    get(entity, 'downloadButton.entity.fieldMedia.entity.fieldMediaDocument.entity.url')
                  }
                  text={get(entity, 'download.entity.absoluteLink.title') || get(entity, 'downloadButton.entity.title')}
                  className="download-button"
                  target="_blank"
                  icon="download"
                  iconAlign="left"
                />
              )}
              {get(entity, 'media') && (
                <Image
                  className="step__image"
                  src={
                    isMobile
                      ? get(entity, 'media.entity.images.medium.url')
                      : get(entity, 'media.entity.images.wide.url')
                  }
                  alt={get(entity, 'media.entity.images.alt') || get(entity, 'title')}
                />
              )}
            </Col>
          </Row>
        ))}
      </Container>
    </Container>
  )
}

export default StepByStep
